import React from 'react';
import './CreatorTestimonials.css';
import { Quote } from 'lucide-react';

function CreatorTestimonials() {
  const testimonials = [
    {
      quote:
        "After 6 months of consistency, I'm still at 37 subscribers. I know I need to cross-post but it's exhausting.",
      author: 'Anonymous',
      role: 'Substack Creator',
      subscribers: 'Researched User',
      avatar: 'SC',
    },
    {
      quote:
        "We spend 3-4 hours EVERY WEEK repurposing. If something could automate that, I'd pay for it.",
      author: 'Anonymous',
      role: 'Digital Marketing Agency',
      subscribers: 'Researched User',
      avatar: 'DM',
    },
    {
      quote:
        'We break one article into 15-20 assets weekly. The biggest bottleneck is reformatting for each platform.',
      author: 'Anonymous',
      role: 'Newsletter Creator',
      subscribers: 'Researched User',
      avatar: 'NC',
    },
  ];

  return (
    <section className='testimonials'>
      <div className='testimonials-container'>
        <h2 className='testimonials-title'>
          What 50+ Newsletter Creators Told Us
        </h2>

        <div className='testimonials-grid'>
          {testimonials.map((testimonial, index) => (
            <div key={index} className='testimonial-card'>
              <Quote size={32} className='quote-icon' />
              <p className='testimonial-quote'>"{testimonial.quote}"</p>
              <div className='testimonial-author'>
                <div className='author-avatar'>{testimonial.avatar}</div>
                <div className='author-info'>
                  <strong>{testimonial.author}</strong>
                  <span>{testimonial.role}</span>
                  <span className='subscribers'>{testimonial.subscribers}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className='founder-section'>
        <div className='founder-card'>
          <div className='founder-avatar'>AS</div>
          <div className='founder-content'>
            <h3 className='founder-greeting'>Hi, I'm Adhithyan 👋</h3>
            <p className='founder-story'>
              I interviewed 50+ newsletter creators and discovered the #1 growth
              blocker:
              <strong>
                {' '}
                repurposing takes 4 hours weekly, so most creators skip it.
              </strong>
            </p>
            <p className='founder-story'>
              I built this because manual cross-posting killed my own newsletter
              growth. I'm looking for 20 creators to test this and tell me
              what's missing.
            </p>
            <div className='founder-links'>
              <a
                href='https://x.com/adhbuilds'
                target='_blank'
                rel='noopener noreferrer'
                className='founder-link'
              >
                X →
              </a>
              <a
                href='https://linkedin.com/in/adhithyan-s-3b7690280/'
                target='_blank'
                rel='noopener noreferrer'
                className='founder-link'
              >
                LinkedIn →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CreatorTestimonials;
